import BaseInput from '@/components/Inputs/BaseInput.vue'
import BaseSelect from '@/components/Inputs/BaseSelect.vue'
import BaseDropdown from '@/components/BaseDropdown.vue'
import Modal from '@/components/Modal.vue'
import BaseButton from '@/components/BaseButton.vue'
import Badge from '@/components/Badge.vue'
import BaseCheckbox from '@/components/Inputs/BaseCheckbox.vue'
import BaseSwitch from '@/components/BaseSwitch.vue'
import BaseRadio from '@/components/Inputs/BaseRadio'
import BaseProgress from '@/components/BaseProgress'
import BasePagination from '@/components/BasePagination'
import BaseAdvancedTable from '@components/BaseAdvancedTable'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Input, Tooltip, Popover } from 'element-ui'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

import JsonCSV from 'vue-json-csv'

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge)
    Vue.component(BaseButton.name, BaseButton)
    Vue.component(BaseCheckbox.name, BaseCheckbox)
    Vue.component(BaseInput.name, BaseInput)
    Vue.component(BaseSelect.name, BaseSelect)
    Vue.component(BaseDropdown.name, BaseDropdown)
    Vue.component(BasePagination.name, BasePagination)
    Vue.component(BaseProgress.name, BaseProgress)
    Vue.component(BaseRadio.name, BaseRadio)
    Vue.component(BaseSwitch.name, BaseSwitch)
    Vue.component('BaseAdvancedTable', BaseAdvancedTable)
    Vue.component(Modal.name, Modal)
    Vue.component(Input.name, Input)
    Vue.component('validation-provider', ValidationProvider)
    Vue.component('validation-observer', ValidationObserver)
    Vue.component('downloadCsv', JsonCSV)
    Vue.use(Tooltip)
    Vue.use(Popover)
  }
}

export default GlobalComponents
